import { createAsyncActions } from "~/utils/store";
import moment from "moment";
import { BOARD_TYPES, BOARD_ID_MAP } from './constants';

export const BOARD_LOAD = createAsyncActions("@@MARKETING/LOAD");
export const BOARD_MOVE_ITEM = createAsyncActions('@@MARKETING/MOVE_ITEM');
export const BOARD_DUPLICATE_ITEM = createAsyncActions('@@MARKETING/DUPLICATE_ITEM');
export const SET_BOARD_TYPE = '@@MARKETING/SET_BOARD_TYPE';
export const SET_PERIOD = '@@MARKETING/SET_PERIOD';

// Re-export board types for backwards compatibility
export { BOARD_TYPES };

// Set board type action
export const setBoardType = (boardType) => ({
  type: SET_BOARD_TYPE,
  payload: boardType
});

// Set period action  
export const setPeriod = (month, year) => ({
  type: SET_PERIOD,
  payload: { month, year }
});

// Load board data with board type and period support
export const load = (boardType = 'missoes', month = null, year = null, showLoading = false) => {
  const boardId = BOARD_ID_MAP[boardType];
  const params = new URLSearchParams({ board_id: boardId });
  
  // Add period parameters if provided
  if (month) params.append('month', month);
  if (year) params.append('year', year);
  
  const url = `/boards?${params.toString()}`;
  
  return {
    type: BOARD_LOAD.INIT,
    payload: {
      request: {
        method: 'GET',
        url,
        showLoading,
      },
      boardType: boardType,
      month,
      year
    }
  };
};

// Move item between columns
export const moveItem = (data, boardType = BOARD_TYPES.MISSOES) => {
  const boardId = boardType === BOARD_TYPES.CONVITES ? 2 : 1;
  
  return {
    type: BOARD_MOVE_ITEM.INIT,
    payload: {
      request: {
        method: 'put',
        url: `/boards/${data.draggableId}/move/${data.destination.droppableId}?board_id=${boardId}`,
        data: data,
        showLoading: false,
      },
      boardType
    }
  };
};

// Duplicate item
export const duplicateItem = (data, boardType = BOARD_TYPES.MISSOES) => {
  const boardId = boardType === BOARD_TYPES.CONVITES ? 2 : 1;
  
  return {
    type: BOARD_DUPLICATE_ITEM.INIT,
    payload: {
      request: {
        method: 'post',
        url: `/boards/item/${data.id}/duplicate?board_id=${boardId}`,
        showLoading: false,
      },
      data,
      boardType
    }
  };
};

// Helper functions for period navigation
export const loadCurrentPeriod = (boardType = BOARD_TYPES.MISSOES) => {
  const now = moment();
  return load(boardType, now.month() + 1, now.year());
};

export const loadPreviousPeriod = (currentMonth, currentYear, boardType = BOARD_TYPES.MISSOES) => {
  const current = moment({ month: currentMonth - 1, year: currentYear });
  const previous = current.subtract(1, 'month');
  return load(boardType, previous.month() + 1, previous.year());
};

export const loadNextPeriod = (currentMonth, currentYear, boardType = BOARD_TYPES.MISSOES) => {
  const current = moment({ month: currentMonth - 1, year: currentYear });
  const next = current.add(1, 'month');
  return load(boardType, next.month() + 1, next.year());
};